import { Button } from "@twinkltech/web-ui";

export const ActionLink = ({
  children,
  disabled,
  ...props
}: React.ComponentProps<typeof Button>) => (
  <Button
    {...props}
    className={[
      "justify-start hover:bg-neutral-150 rounded-md px-200 py-150 font-normal",
      disabled && "opacity-50 bg-white!",
    ]
      .filter(Boolean)
      .join(" ")}
    disabled={disabled}
    variant="ghost"
  >
    {children}
  </Button>
);
